import {
  Col,
  Row,
  Typography,
  Button,
  Form,
  Input,
  Spin,
  Modal,
  Checkbox,
  Divider,
  Image
} from "antd";
import UserOutlined from "@ant-design/icons/lib/icons/UserOutlined";
import { LockOutlined, LoginOutlined, RollbackOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { useForm } from "antd/lib/form/Form";
import { APIEndpointWeb, webapi } from "@client/web";
import {
  CK_ACCESS_DATA_ROLE,
  CK_ACCESS_TOKEN,
  CK_SHARED_TOKEN,
  CK_TYPE,
} from "@constant/constant";
import { Cookies, useCookies } from "react-cookie";
import { Redirect, useHistory } from "react-router-dom";
import { AxiosError } from "axios";
import R from "@routers/R";
import ModalPolicy from "./AllModal/ModalPolicy/ModalPolicy";
import ModalTermsOfUse from "./AllModal/ModalCheckEkyc/ModalTermsOfUse/ModalTermsOfUse";
import CheckUser from "./AllModal/ModalCheckEkyc/CheckUser";
import logo_oneplatform from "../Image/logo_oneplatform.png"
import { tuple } from "antd/lib/_util/type";
import { result } from "lodash";

export interface Idatalogin {
  username: string;
  password: string;
}
export interface userDisplay {
  insurer: string;
  name: string;
  ref_code: string;
}
const Login: React.FC = (): JSX.Element => {
  const [form] = useForm();
  const history = useHistory();
  const [goToPath, setGoToPath] = useState("");
  const [checkMessage, setcheckMessage] = useState("");
  const [, forceUpdate] = useState({});
  const params = new URLSearchParams(window.location.search);
  const [loading, setLoading] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const getCookies = new Cookies();
  const [cookies, setCookie] = useCookies([
    // "shared_token"
    // CK_TYPE,
    CK_SHARED_TOKEN,
    // CK_ACCESS_TOKEN,
    // CK_ACCESS_DATA_ROLE
  ]);
  const [isModalOpenTerms, setIsModalOpenTerms] = useState(false);
  const [isModalOpenPolicy, setIsModalOpenPolicy] = useState(false);
  const [isModalCheckEkyc, setIsModalCheckEkyc] = useState(false);
  const [checked, setChecked] = useState(Boolean);
  const [dataEkyc, setDataEkyc] = useState<any>("");
  const [resUserDisplay, setResUserDisplay] = useState<userDisplay>();
  const [WindowResize, setWindowResize] = useState(Number);
  useEffect(() => {
    window.addEventListener("resize", handleWindowResize);
    handleWindowResize();
    const script = document.createElement("script");
    script.src = "https://www.google.com/recaptcha/api.js?render=" + process.env[`REACT_APP_CAPTCHA`];
    script.async = true;
    document.body.appendChild(script);
  }, [WindowResize]);
  useEffect(() => {
    let handleWindowResize = () => {
      setWindowResize(window.innerWidth);
    };
    window.addEventListener("resize", handleWindowResize);
    handleWindowResize();
    var sharedToken = params.get("shared_token");
    if (window.innerWidth < 1024) {
      if (sharedToken) {
        // dataLogin(sharedToken);
      }
      else if (window.innerWidth > 1024) {
        history.replace("/login")
      }

    }
  }, [WindowResize]);
  const handleWindowResize = () => {
    setWindowResize(window.innerWidth);
  };
  const showModal1 = () => {
    setIsModalOpenTerms(true);
  };

  const handleOk1 = () => {
    setIsModalOpenTerms(false);
  };

  const handleCancel1 = () => {
    setIsModalOpenTerms(false);
  };
  const showModal2 = () => {
    setIsModalOpenPolicy(true);
  };

  const handleOk2 = () => {
    setIsModalOpenPolicy(false);
  };

  const handleCancel2 = () => {
    setIsModalOpenPolicy(false);
  };
  const handleOk = () => {
    setIsModalCheckEkyc(false)
  };
  const checkuser = (data: any) => {
    setDataEkyc(data)
    setIsModalCheckEkyc(true)
  };
  // var checkType = params.get("check-type");
  // if (!checkType) {
  //   history.push('/login-type')
  // }
  function handleMenuClick() {
    history.replace("/login");
  }

  const onFinish = (): void => {
    const formSet: {
      username: string;
      password: string;
    } = form.getFieldsValue();
    const payload: Idatalogin = {
      username: formSet.username,
      password: formSet.password,
    };
    dataLogin(payload);
  };
  const dataLogin = async (payload: Idatalogin) => {
    var tokenapigrecaptcha: any
    try {
      await grecaptcha.execute(process.env[`REACT_APP_CAPTCHA`] || '', { action: 'login' }).then((token) => { tokenapigrecaptcha = token })
    } catch (error) {
      Modal.error({ title: 'ตรวจพบความผิดปกติของผู้ใช้ กรุณารอสักครู่', okText: 'ตกลง', });
      setLoading(false);
      return false
    }
    const data = {
      username: payload.username,
      password: payload.password,
      token_captcha: tokenapigrecaptcha
    };
    setLoading(true)
    webapi.post(APIEndpointWeb.Login, data, {
      withCredentials: true,
      headers: {
        'Accept': 'application/json',
        'Content-type': 'application/json',
        "Access-Control-Allow-Credentials": true,
      }
    }).then(async (res) => {
      try {
        try {
          const dataAccess: any = await webapi.get(`${APIEndpointWeb.GetInfo}`,
            {
              withCredentials: true,
              // headers: { Authorization: `Bearer ${res?.result.token}` },
            }
          );
          // setCookie(CK_ACCESS_DATA_ROLE, dataAccess.data?.result?.user_type, { path: "/", maxAge: 3600 * 24, secure: true, sameSite: "lax"});
          if (dataAccess.data?.result?.user_type === "User") {
            // check ekyc
            try {
              const dataCheck: any = await webapi.get(`${APIEndpointWeb.GetCheckekyc}`,
                {
                  // headers: { Authorization: `Bearer ${res?.result.token}` },
                }
              );
              if (dataCheck.data.result === true) {
                // setCookie(CK_SHARED_TOKEN, res?.result.token, { path: "/", maxAge: 3600 * 24, secure: true, httpOnly: true});
                // setCookie(CK_ACCESS_TOKEN, dataAccess.data?.result?.access_token, { path: "/", maxAge: 3600 * 24, secure: true});
                if (WindowResize < 1024) {
                  history.replace("/request");
                }
                else if (WindowResize >= 1024) {
                  history.replace("/request-list");
                }
              }
              else if (dataCheck.data.result === false) {
                checkuser(dataCheck.data.result)
              }
            } catch (error) {
              const err = error as AxiosError;
              setcheckMessage(err.response?.data?.message);
            }
            // check agent
          } else if (dataAccess.data?.result?.user_type === "Agent") {
            // if (dataAccess.data.result.expired === 0) {
            //   history.replace("/newpassword-expiredcode")
            // } else {
            history.replace("/dashboard-insurance");
            // window.location.href="/dashboard-insurance"
            // setCookie(CK_SHARED_TOKEN, res?.result.token, { path: "/", maxAge: 3600 * 24, secure: true, sameSite: "none", httpOnly: true});
            // setCookie(CK_ACCESS_TOKEN, dataAccess.data?.result?.access_token, { path: "/", maxAge: 3600 * 24, secure: true, httpOnly: true});
            // }

          } else if (dataAccess.data?.result?.user_type === "Superadmin") {
            history.replace("/dashboard-superadmin");
          }
          else if (dataAccess.data?.result?.user_type === "Med") {
            // setCookie(CK_SHARED_TOKEN, res?.result.token, { path: "/", maxAge: 3600 * 24, secure: true, httpOnly: true});
            // setCookie(CK_ACCESS_TOKEN, dataAccess.data?.result?.access_token, { path: "/", maxAge: 3600 * 24, secure: true, httpOnly: true});
            history.replace("/medical-pending");
          }
          else {
            Modal.error({
              title: "รหัสผู้ใช้งานของคุณไม่ถูกต้อง",
              content: 'กรุณาลองใหม่อีกครั้ง',
              okText: "ตกลง",
              okButtonProps: {
                type: "primary",
              },
              cancelButtonProps: {
                type: "default",
              },
              onOk() {
                setTimeout(() => {
                  handleMenuClick()
                }, 1000);
              },
            });
          }
          setLoading(false);
        } catch (error) {
          console.log(error);
        }
      } catch (error) {
        const err = error as AxiosError;
        setcheckMessage(err.response?.data?.message);
        if (err.response?.data?.message === "Invalid SharedToken") {
          history.push(
            "/check-user?check-data=" + err.response?.data?.message
          );
        }
        if (err.response?.data?.message === "Invalid Data") {
          history.push(
            "/check-user?check-data=" + err.response?.data?.message
          );
        }
      }
      setLoading(false);

    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 400) {
          Modal.error({
            title: "ชื่อผู้ใช้งานหรือรหัสผ่านไม่ถูกต้อง",
            okText: "ตกลง",
          });
        }
      } else {
        Modal.error({
          title: error.toString(),
          okText: "ตกลง",
        });
      }
      setLoading(false);
    })
  };
  useEffect(() => {
    forceUpdate({});
  }, []);
  const handleGoToPath = (path: string): void => {
    setGoToPath(path);
  };
  function onChangeChecked(e: any) {
    setChecked(e.target.checked)
  }
  const validate = () => {
    return username && password;
  };
  const registerAgent = () => {
    // window.location.href = `https://uat-spaceadmin.inet.co.th/register?project="FMR"&check-type="Agent"&url="https://uat-fmr.inet.co.th/login-type`
    window.location.href = `https://spaceadmin.one.th/register?project=FMR&check-type=Agent&url=` + window.location.href
  }
  return (
    <div className="example"
    >
      {goToPath ? <Redirect to={goToPath} /> : null}
      <Spin tip="กำลังเข้าสู่ระบบ..." spinning={loading} style={{ minHeight: "100vh" }}>
        <Row style={{ height: "100vh" }} className=" pd-right cardboder">
          <Col
            xs={22}
            sm={22}
            md={20}
            lg={15}
            xl={9}
            xxl={9}
            style={{ alignSelf: "center", }}
            className="input-responsive colBackgroud"
          >
            {/* <Avatar size={100} className="Logo" /> */}
            <div style={{ color: "#2E6872" }} className="login-responsive mb-4">
              <Typography.Text
                className="fontstyle"
              >
                ยินดีต้อนรับ{" "}
              </Typography.Text>
              <UserOutlined className="Iconstyle" />
              <br />
              <Typography.Text style={{ color: "#2E6872", fontSize: "20px" }}>
                ลงชื่อเข้าใช้งานเพื่อดำเนินการต่อ
              </Typography.Text>
            </div>
            <Form
              form={form}
              name="normal_login"
              className="login-form"
              initialValues={{ remember: true }}
              onFinish={onFinish}
            >
              <div className="mt-4">
                <Typography.Text style={{ color: "#2E6872", fontSize: "18px" }}>
                  ชื่อผู้ใช้งาน
                </Typography.Text>
                <Form.Item
                  name="username"
                  rules={[{ required: true, message: "กรุณากรอกชื่อผู้ใช้งาน" }]}
                >
                  <Input
                    style={{ height: "45px", borderRadius: "40px" }}
                    className="mt-2"
                    prefix={<UserOutlined className="site-form-item-icon" />}
                    placeholder="ชื่อผู้ใช้งาน"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                  />
                </Form.Item>
              </div>
              <Typography.Text style={{ color: "#2E6872", fontSize: "18px" }}>
                รหัสผ่าน
              </Typography.Text>
              <Form.Item
                name="password"
                rules={[{ required: true, message: "กรุณากรอก รหัสผ่าน" }]}
              >
                <Input.Password
                  className="mt-2"
                  style={{ height: "45px", borderRadius: "40px" }}
                  prefix={<LockOutlined className="site-form-item-icon" />}
                  type="password"
                  placeholder="รหัสผ่าน"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </Form.Item>
              <Row justify="end" style={{ marginTop: '-20px' }}>
                <Button
                  type="text"
                  onClick={(): void => {
                    handleGoToPath(R.HomeRouter.choiceforgetpassword.link);
                  }}
                  style={{ fontSize: "14px", color: "#A8A8A8" }}
                >
                  ลืมรหัสผ่าน ?
                </Button>
              </Row>
              <Row className="mt-3">
                <Col>
                  <Checkbox onChange={onChangeChecked}>รับทราบ</Checkbox><a type="primary" onClick={showModal1} style={{ color: '#3a7c89', fontSize: '15px' }}>ข้อกำหนดการใช้บริการ FMR</a> และ <a type="primary" onClick={showModal2} style={{ color: '#3a7c89', fontSize: '15px' }}>นโยบายคุ้มครองข้อมูลส่วนบุคคล</a>
                </Col>
                <Modal title="ข้อกำหนดการใช้บริการ FMR"
                  style={{}}
                  visible={isModalOpenTerms}
                  onOk={handleOk1}
                  onCancel={handleCancel1}
                  footer={
                    <Button
                      type="primary"
                      size="middle"
                      onClick={handleCancel1}
                    >
                      ปิด
                    </Button>
                  }>
                  <ModalTermsOfUse />
                </Modal>
                <Modal title="นโยบายคุ้มครองข้อมูลส่วนบุคคล"
                  visible={isModalOpenPolicy}
                  onOk={handleOk2}
                  onCancel={handleCancel2}
                  footer={
                    <Button
                      type="primary"
                      size="middle"
                      onClick={handleCancel2}
                    >
                      ปิด
                    </Button>
                  }>
                  <ModalPolicy />
                </Modal>
              </Row>
              <Form.Item>
                <Button
                  className="mt-3"
                  style={{
                    fontSize: "20px",
                    color: checked && username && password ? '#fff' : '#b8b8b8 ',
                    backgroundColor: checked && username && password ? '#376d77' : '#f4f4f4',
                    height: "45px",
                    borderRadius: "40px",
                    width: "-webkit-fill-available",
                  }}
                  htmlType="submit"
                  disabled={
                    checked === false ? true : false || !validate()
                  }
                >
                  เข้าสู่ระบบ
                </Button>
                {/* <Divider plain>or login with</Divider> */}
                <Row style={{ display: 'flex', justifyContent: 'center' }} className="mt-3">
                  <Col>
                    <p style={{ fontSize: '16px' }}>คุณยังไม่มีบัญชีใช่หรือไม่ ? &nbsp;&nbsp;&nbsp;</p>
                  </Col>
                  <Col>
                    <a onClick={registerAgent} style={{ fontSize: '16px', color: '#4fa5b2' }} target="_blank">สร้างบัญชี</a>
                  </Col>
                </Row>

              </Form.Item>
            </Form>
          </Col>
        </Row>
      </Spin>
      <Modal
        style={{ height: "50%" }}
        visible={isModalCheckEkyc}
        onCancel={handleOk}
        footer={
          <Button
            type="primary"
            size="middle"
            onClick={handleOk}
          >
            ปิด
          </Button>
        }>
        <CheckUser dataEkyc={dataEkyc} checkMessage={checkMessage} />
      </Modal>
    </div>
  );
};
export default Login;
